import { render, staticRenderFns } from "./gateway.vue?vue&type=template&id=7115bf86&scoped=true"
import script from "./gateway.vue?vue&type=script&lang=js"
export * from "./gateway.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7115bf86",
  null
  
)

export default component.exports